import { useTranslation } from 'react-i18next';
import { icons } from '../../../../../../../shared/icons';
import { formatDateTime } from '../../../../../../../utils/FormatDate';
import MuiGrid from '../../../../../UI/MuiGrid/MuiGrid';
import GridOptionsFajlovi from './GridOptionsFajlovi';

const GridProviderFajlovi = ({
  data,
  loading,
  handleOpenFile,
  handleOpenDeleteDialog,
  downloadFile,
  editFile,
  aktiviranProjekat,
  canManage,
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: '',
      width: 50,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptionsFajlovi
          openFile={() => handleOpenFile(e.row)}
          handleOpenDeleteDialog={() => handleOpenDeleteDialog(e.id)}
          downloadFile={() => downloadFile(e.row.path, e.row.name)}
          editFile={() => editFile(e.row)}
          canManage={canManage}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptionsFajlovi>
      ),
    },
    {
      field: 'parentNaziv',
      headerName: t('projectProgress.parent'),
      width: 500,
    },
    {
      field: 'nazivVrsteDokumenta',
      headerName: t('projectProgress.documentType'),
      width: 200,
    },
    {
      field: 'name',
      headerName: t('name'),
      width: 270,
    },
    {
      field: 'opis',
      headerName: t('description'),
      width: 350,
    },
    {
      field: 'vremeKreiranja',
      headerName: t('projectProgress.time'),
      width: 150,
      renderCell: (item) => {
        return (
          <span>
            {item.row.vremeKreiranja
              ? formatDateTime(item.row.vremeKreiranja)
              : null}
          </span>
        );
      },
    },
    {
      field: 'size',
      headerName: t('projectProgress.size'),
      width: 120,
      renderCell: (item) => {
        return <span>{(item.row.size / 1024 ** 2).toFixed(2)} MB</span>;
      },
    },
  ];

  return (
    <div
      style={{
        marginTop: '10px',
        height: '500px',
        width: '99%',
      }}
    >
      <MuiGrid data={data} loading={loading} columns={columns} />
    </div>
  );
};

export default GridProviderFajlovi;
